export function mapStatus(type, forwardNumber) {
  if (type === 'FORWARD') {
    return forwardNumber;
  } else {
    return type;
  }
}